<template>
    <div class="base-psy-success" :class="{ 'base-psy-success-sp': $store.state.screen == 1 }">
        <header class="header">
            <div class="goback" @click="onClose">
                <img class="back" src="~images/back.png" />
                <div class="title">支付成功</div>
            </div>
            <div class="service-img" @click="toSer">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </header>
        <div class="head-title">
            <img src="~images/success.png" />
            <div>恭喜您，支付成功 !</div>
        </div>
        <div class="content">
            <div class="item">订单：{{ orderId }}</div>
            <div class="item">金额：{{ money }}{{ unit }}</div>
            <div class="item">类型：{{ payType }}支付</div>
            <div class="item">状态：<span class="sol">支付成功</span></div>
            <div class="item">时间：{{ time }}</div>
            <div class="item">备注：因网络原因部分订单可能延时发货，请稍等片刻或联系客服。</div>
            <div class="btn" @click="onClose">返回</div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    // 进入路由之前
    beforeRouteEnter(to, from, next) {
        next(vm => {
            // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例
            if (vm.config.system == 1) {
                // 竖屏
                window.Android.setOriPortrait()
            } else {
                // 竖屏
                window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'forcePortrait' })
            }
        })
    },
    name: 'BasePaySuccess',
    data() {
        return {
            orderId: null,
            unit: null,
            money: null,
            time: null,
            payType: null
        }
    },
    methods: {
        // 关闭支付页面
        onClose() {
            let that = this
            sessionStorage.clear()
            if (that.config.system == 1) {
                window.Android.closePay(false, that.orderID)
                // 恢复正常屏幕
                window.Android.setOriBehind()
            } else if (that.config.system == 2) {
                window.webkit.messageHandlers.wz_callOC.postMessage({
                    method: 'closePay',
                    param: {
                        payState: false,
                        payId: that.orderID
                    }
                })
                // 恢复正常屏幕
                window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'forceLandscapeRight' })
            }
        },
        toSer() {
            this.$router.push('/base-service')
            if (this.config.system == 1) {
                // 恢复正常屏幕
                window.Android.setOriBehind()
            } else {
                // 恢复正常屏幕
                window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'forceLandscapeRight' })
            }
        }
    },
    created() {
        this.orderId = this.$route.query.order
        this.unit = this.$route.query.type == 2 ? '平台币' : '元'
        this.payType = this.$route.query.type == 2 ? '平台币' : this.$route.query.type == 1 ? '微信' : '支付宝'
        this.money = this.$route.query.money
        this.time = moment.unix(this.$route.query.time).format('YYYY-MM-DD HH:mm')
    }
}
</script>

<style lang="scss" scoped>
.base-psy-success {
    width: 1080px;
    height: 100%;
    padding-bottom: 60px;
    background: #fff;
    overflow-y: scroll;

    .header {
        width: 100%;
        height: 132px;
        // height: 340px;
        background: #FF6B21;
        position: sticky;
        top: 0;
        display: flex;
        align-items: center;

        .goback {
            height: 132px;
            display: flex;
            align-items: center;

            .back {
                width: 72px;
                height: 72px;
                margin-left: 40px;
            }

            .title {
                font-size: 51px;
                margin-left: 35px;
            }
        }

        .service-img {
            width: 192px;
            height: 132px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 0;

            .ser {
                width: 72px;
                height: 72px;
            }
        }
    }

    .head-title {
        font-size: 34px;
        background: #FF6B21;
        padding-top: 43px;
        padding-bottom: 85px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 198px;
            height: 198px;
            margin-bottom: 43px;
        }
    }

    .content {
        color: #333;
        font-size: 40px;
        padding: 150px;
        overflow: hidden;

        .item {
            margin-bottom: 80px;

            .sol {
                color: #47A252;
            }
        }

        .btn {
            width: 792px;
            height: 116px;
            font-size: 40px;
            color: #fff;
            border-radius: 58px;
            background: #FF6B21;
            margin: 115px auto 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

$color: #FF6C22; // 主体颜色

.base-psy-success-sp {
    width: 82%;
    height: 80%;
    border-radius: 60px 0 0 0;
    padding-bottom: 90px;
    background: #fff;
    position: absolute;
    right: 0;
    bottom: 0;

   
    .header {
        width: 100%;
        height: 240px;
        background: #FF6B21;
        position: sticky;
        top: 0;
        display: flex;
        align-items: center;

        .goback {
            height: 240px;
            display: flex;
            align-items: center;

            .back {
                width: 130px;
                height: 130px;
                margin-left: 80px;
            }

            .title {
                font-size: 92px;
                margin-left: 63px;
            }
        }

        .service-img {
            width: 290px;
            height: 130px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 0;

            .ser {
                width: 130px;
                height: 130px;
            }
        }
    }

    .head-title {
        font-size: 43px;
        background: #FF6B21;
        padding-top: 77px;
        padding-bottom: 153px;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 357px;
            height: 357px;
            margin-bottom: 77px;
        }
    }

    .content {
        color: #333;
        font-size: 72px;
        padding: 136px;
        overflow: hidden;

        .item {
            margin-bottom: 144px;

            .sol {
                color: #47A252;
            }
        }

        .btn {
            width: 100%;
            height: 210px;
            font-size: 72px;
            color: #fff;
            border-radius: 105px;
            background: #FF6B21;
            margin: 207px auto 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>